// extracted by mini-css-extract-plugin
export var addressFields = "_g0-0";
export var animationContainer = "_g0-1";
export var footer = "_g0-2";
export var lineItems = "_g0-3";
export var modalContent = "_g0-4";
export var orderName = "_g0-5";
export var strong = "_g0-6";
export var warning = "_g0-7";